import { useMemo } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { ByzzerLink } from '@/components/form';
import './EmailUnsubscribe.scss';

const baseClassName = 'email-unsubscribe';

const NOTIFICATION_PREFERENCES_PATH = '/dashboard/user_profile/personal';

const unsubscribeMessages: Record<string, string> = {
    unsubscribe_email_notification_dod: 'Successfully unsubscribed.',
    email_link_action_failed: "Couldn't perform the action, the link might be expired or already used."
};

const DEFAULT_MESSAGE = 'You have been unsubscribed from email notifications.';

const EmailUnsubscribe = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const code = searchParams.get('code');

    const message = useMemo(() => {
        if (!code) return DEFAULT_MESSAGE;
        return unsubscribeMessages[code] ?? DEFAULT_MESSAGE;
    }, [code]);

    return (
        <div className={baseClassName}>
            <p className={`${baseClassName}__message`}>
                {message}{' '}
                Review changes on{' '}
                <ByzzerLink
                    label={'Notification Preferences'}
                    onClick={() => navigate(NOTIFICATION_PREFERENCES_PATH)}
                />{' '}
                page.
            </p>
        </div>
    );
};

export default EmailUnsubscribe;
